import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import RoleService from '@/services/UsersServices/RoleService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    id: null,
    submitting: false,
    error: null,
    successOnDelete: '',
};

export const deleteRole = createAsyncThunk(
    'role/deleteRole',
    async (roleId, { rejectWithValue }) => {
        try {
            const response = await RoleService.deleteRole(roleId);
            return {
                roleId,
                data: response.data,
            };
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const deleteRoleSlice = createSlice({
    name: 'deleteRole',
    initialState: model,
    reducers: {
        resetDeleteRoleStateOnError: (state) => {
            state.error = null;
        },
        resetDeleteRoleStateOnSuccess: (state) => {
            state.successOnDelete = '';
        },
    },
    extraReducers: (builder) => {
        // delete role
        builder.addCase(deleteRole.pending, (state, action) => {
            state.id = action.meta.arg;
            state.submitting = true;
        }).addCase(deleteRole.fulfilled, (state) => {
            state.id = null;
            state.submitting = false;
            state.successOnDelete = 'Role deleted successfully!';
        }).addCase(deleteRole.rejected, (state, action) => {
            state.submitting = false;
            state.error = extractError(action);
        });
    },
});

export const {
    resetDeleteRoleStateOnError,
    resetDeleteRoleStateOnSuccess,
} = deleteRoleSlice.actions;

export default deleteRoleSlice.reducer;
